var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustwallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    exponent: 92384,
    className: "mt-4 h-auto w-[180px]",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.710815 6.67346L19.4317 0.606445V42.6064C6.05944 37.0059 0.710815 26.2727 0.710815 20.207V6.67346Z",
    fill: "#0500FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1537 6.67346L19.4329 0.606445V42.6064C32.8051 37.0059 38.1537 26.2727 38.1537 20.207V6.67346Z",
    fill: "url(#paint0_linear_524_7586892384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_7586892384",
    x1: 33.1809,
    y1: -2.33467,
    x2: 19.115,
    y2: 42.0564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0500FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustwallet);
export default __webpack_public_path__ + "static/media/trustwallet.adcd06b0d1c104f1d52e56d19297d360.svg";
export { ForwardRef as ReactComponent };